(() => {
  if (window.PsychicHermanoHeadingStructure) return;
  window.PsychicHermanoHeadingStructure = true;

  const setText = (element, value) => {
    if (element && value && element.textContent.trim() !== value) element.textContent = value;
  };

  const applyCollectionHeadings = () => {
    const map = document.querySelector('[data-ph-collection-heading-map]');
    const guide = document.querySelector('.ph-collection-guide');
    if (!map || !guide) return;

    setText(guide.querySelector('.ph-collection-guide__intro h2'), map.dataset.mainHeading);

    const panelHeadings = guide.querySelectorAll('.ph-guide-panel > h2');
    setText(panelHeadings[0], map.dataset.matchHeading);
    setText(panelHeadings[1], map.dataset.chooseHeading);
    setText(panelHeadings[2], map.dataset.relatedHeading);
    setText(panelHeadings[3], map.dataset.faqHeading);
    setText(guide.querySelector('.ph-guide-cta h2'), map.dataset.ctaHeading);
  };

  const run = () => applyCollectionHeadings();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
